import { AyurmaStrings } from "../../../i18n/ayurma";

import classes from "./KeyMetricsGlossary.module.css";

interface Props {
  terms: AyurmaStrings["glossary"]["terms"];
}

/**
 * Static explainers for the resting gas-exchange metrics. Content is entirely
 * frontend-owned — the report payload has no glossary.
 *
 * Keyed off the dictionary object rather than an array so a missing translation
 * is a compile error rather than a silently shorter grid.
 */
const KeyMetricsGlossary = ({ terms }: Props): JSX.Element => {
  const order: (keyof Props["terms"])[] = [
    "RER",
    "VO2",
    "VCO2",
    "VT",
    "BF",
    "VE",
  ];

  return (
    <div className={classes.grid}>
      {order.map((key) => (
        <div className={classes.cell} key={key}>
          <div className={classes.term}>{terms[key].term}</div>
          <div className={classes.text}>{terms[key].text}</div>
        </div>
      ))}
    </div>
  );
};

export default KeyMetricsGlossary;
